var module = angular.module('main.resellerorder');

module.component('caResellerOrderSearch',{
    templateUrl: 'main/resellerorder/genericcomponents/resellerordersearch.cmp.tpl.html',
    bindings: {
        searchTerm: '<',
        onResellerOrderSelected: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($scope, $state, $stateParams, $translate, ResellerOrdersApiService, confirmationDialogService,
    printLanguageConfirmationDialogService, loadSpinnerService, ToasterService) {
    var vm = this;

    //Properties
    vm.resellerOrders = [];
    vm.resellerOrderPrintList = [];
    vm.resellerOrderSaleList = [];
    vm.searchTerm = {};
    vm.searchTerm.orderStatuses = [];
    vm.searchTerm.locations = [];
    vm.searchTerm.selectedFromLocation = {};
    vm.currentPage = 1;
    vm.totalItems = 0;
    vm.itemsPerPage = 15;
    vm.returnFilter = false;
    vm.isFilterOrderForInvoice = false;


    vm.filterCreated = true;
    vm.filterOpen = true;
    vm.filterClosed = true;
    vm.filterOrder = true;
    vm.filterReturnOrder = true;
    vm.filterAll = true;

    vm.isProcessing = false;

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.loadResellerOrders = loadResellerOrders;
    vm.loadResellerReturnOrders = loadResellerReturnOrders;
    vm.loadAllResellerOrders = loadAllResellerOrders;
    vm.searchTermChange = searchTermChange;
    vm.filterAllOrders = filterAllOrders;
    vm.getOrderTypeTranslation = getOrderTypeTranslation;
    vm.getStatusTranslation = getStatusTranslation;
    vm.selectOrder = selectOrder;
    vm.createNewOrder = createNewOrder;
    vm.createNewReturnOrder = createNewReturnOrder;
    vm.containsStatus = containsStatus;
    vm.printAllResellerOrders = printAllResellerOrders;
    vm.printAllSelectedResellerOrders = printAllSelectedResellerOrders;
    vm.printSelectedResellerOrder = printSelectedResellerOrder;
    vm.checkToPrintList = checkToPrintList;
    vm.checkToSaleList = checkToSaleList;
    vm.checkAllToPrintList = checkAllToPrintList;
    vm.checkAllToSaleList = checkAllToSaleList;
    vm.getOrderType = getOrderType;
    vm.getAllCheckedToPrintList = getAllCheckedToPrintList;
    vm.getAllCheckedToSaleList = getAllCheckedToSaleList;
    vm.generateSales = generateSales;
    vm.deleteResellerOrder = deleteResellerOrder;
    vm.disableDeleteOrder = disableDeleteOrder;
    vm.disablePrintOrder = disablePrintOrder;
    vm.createReturnOrderFromOrder = createReturnOrderFromOrder;
    vm.disableMakeReturnOrder = disableMakeReturnOrder;
    vm.readyForSale = readyForSale;

    activate();


    function onInit() {
        vm.searchTerm.term = ($stateParams.searchTerm) ? $stateParams.searchTerm : '';
        
        //filterAllOrders();

        $scope.$watch(function() { return vm.currentPage; }, function() { vm.filterAllOrders(); });
    }
    function onChanges() {
    }

    function deleteResellerOrder(order){
        var deleteLink = order.links.find((l) => l.rel === 'delete');
        if(!deleteLink) return;
        confirmationDialogService.showDialog($translate.instant("support.confirmDeleteData")).then(function (deleteConfirmed) {
            if (deleteConfirmed === true) {
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.deleteResellerOrder(deleteLink.href).then(function () {
                }, function (error) {
                    console.log(error);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                    searchTermChange();
                });
            }
        });
    }

    function activate() {
        loadLocations();
        /*
        $scope.$watch(function () {
            return vm.searchTerm.term;
        }, function (oldValue, newValue) {
            if (oldValue !== newValue) {
                filterAllOrders();
            }
        });*/
    }

    function disableDeleteOrder(order) {
        const hasDeleteLink = _.find(order.links, function(o) { return o.rel === 'delete'; }) !== undefined;
        return hasDeleteLink ? false : true;
    }

    function disablePrintOrder(order) {
        const hasPrintLink = _.find(order.links, function(o) { return o.rel === 'canPrintPdf'; }) !== undefined;
        return hasPrintLink ? false : true;
    }

    function disableMakeReturnOrder(order) {
        const hasPrintLink = _.find(order.links, function(o) { return o.rel === 'CanMakeResellerOrderReturnOrder'; }) !== undefined;
        return hasPrintLink ? false : true;
    }

    function createReturnOrderFromOrder(order){
        confirmationDialogService.showDialog($translate.instant("resellerorder.confirmCreateResellerOrderBasedOnOrder")).then(function (create) {
            if (create === true) {
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.createResellerReturnOrderBasedOnOrder(order).then(function (response) {
                    var orderId = response.data.id;
                    $state.go('resellerorder.resellerreturnordermodify', { orderId: orderId});
                }, function (error) {
                    console.log(error);
                    ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                }).then(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function readyForSale(){
        vm.isFilterOrderForInvoice = !vm.isFilterOrderForInvoice;
        searchTermChange();
    }

    function generateSales() {
        ToasterService.showInfo($translate.instant('resellerorder.generatingSales'));
        vm.isProcessing = true;
        ResellerOrdersApiService.createSalesOnClosedFulfillmentLineItems(vm.resellerOrderSaleList).then(function() {
            ToasterService.showSuccess($translate.instant('resellerorder.generateSalesSuccess'));
        }, function(error) {
            ToasterService.showError($translate.instant('resellerorder.generateSalesFailure'));
        }).finally(function() {
            vm.isFilterOrderForInvoice = false;
            vm.isProcessing = false;
            searchTermChange();

        });
    }

    function getAllCheckedToPrintList(){
        if($scope.checkeverything){
            return vm.totalItems;
        }
        
        return vm.resellerOrderPrintList.length;
    }

    function getAllCheckedToSaleList(){
        if($scope.checkeverything){
            return vm.totalItems;
        }
        return vm.resellerOrderSaleList.length;
    }

    function checkAllToPrintList(checked){
        vm.resellerOrderPrintList = [];
        if(checked){
            _.forEach(vm.resellerOrders, function(resellerOrder){
                vm.resellerOrderPrintList.push(resellerOrder.id);
            });
        }
    }

    function checkAllToSaleList(checked){
        vm.resellerOrderSaleList = [];
        if(checked){
            _.forEach(vm.resellerOrders, function(resellerOrder){
                vm.resellerOrderSaleList.push(resellerOrder.id);
            });
        }
    }

    function checkToPrintList(orderId){
        var matchingIndex = _.findIndex(vm.resellerOrderPrintList, function(printId){
            return orderId == printId
        });

        if(matchingIndex >= 0)
            vm.resellerOrderPrintList.splice(matchingIndex, 1);
        else
            vm.resellerOrderPrintList.push(orderId);
        
        if(vm.resellerOrderPrintList.length === 0){
            $scope.checkall = false;
            $scope.checkeverything = false;
        }
    }

    function checkToSaleList(orderId){
        var matchingIndex = _.findIndex(vm.resellerOrderSaleList, function(printId){
            return orderId == printId
        });

        if(matchingIndex >= 0)
            vm.resellerOrderSaleList.splice(matchingIndex, 1);
        else
            vm.resellerOrderSaleList.push(orderId);
        
        if(vm.resellerOrderSaleList.length === 0){
            $scope.checkall = false;
            $scope.checkeverything = false;
        }
    }

    function printAllSelectedResellerOrders(){
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) 
            {
                loadSpinnerService.start('mainSpinner');
    
                
                if($scope.checkeverything){
                    var request = { 
                        filterReturnOrder: vm.filterReturnOrder,
                        filterOrder: vm.filterOrder,
                        locale: result.locale,
                        filter: vm.searchTerm.term,
                        orderStatuses: vm.searchTerm.orderStatuses
                    };
                    
                    ResellerOrdersApiService.getAllSearchedResellerOrderZip(request).then(function (response) {
                    }, function (error) {
                        ToasterService.showError(error.message);
                    }).finally(function () {
                        vm.resellerOrderPrintList = [];
                        $scope.checkall = false;
                        $scope.checkeverything = false;
                        ToasterService.showSuccess($translate.instant('common.done'));
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
                else{
                    var request = { 
                        resellerOrderIds : vm.resellerOrderPrintList,
                        locale: result.locale
                    };

                    ResellerOrdersApiService.getSelectedResellerOrderZip(request).then(function (response) {
                    }, function (error) {
                        ToasterService.showError(error.message);
                    }).finally(function () {
                        vm.resellerOrderPrintList = [];
                        $scope.checkall = false;
                        ToasterService.showSuccess($translate.instant('common.done'));
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
                //ResellerOrdersApiService.getSelectedResellerOrderPdf(request).then(function (response) {
                //}, function (error) {
                //    ToasterService.showError(error.message);
                //}).finally(function () {
                //    vm.resellerOrderPrintList = [];
                //    $scope.checkall = false;
                //    ToasterService.showSuccess($translate.instant('common.done'));
                //    loadSpinnerService.stop('mainSpinner');
                //});
            }   
            
        });
    }

    function printSelectedResellerOrder(orderId){
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) 
            {
                loadSpinnerService.start('mainSpinner');
                var request = { 
                    resellerOrderIds : [orderId],
                    locale: result.locale
                };

                ResellerOrdersApiService.getSelectedResellerOrderZip(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    vm.resellerOrderPrintList = [];
                    $scope.checkall = false;
                    ToasterService.showSuccess($translate.instant('common.done'));
                    loadSpinnerService.stop('mainSpinner');
                });
            }           
        });
    }

    function printAllResellerOrders() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) {
                var request = {
                    orderStatus: vm.searchTerm.orderStatuses.length > 0 ? vm.searchTerm.orderStatuses[0] : '',
                    locale: result.locale
                };

                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.getAllResellerOrdersPdf(request).then(function (response) {
                }, function (error) {
                    console.log(error);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function getOrderType(type){
        if(type.indexOf('Return') !== -1)
            return $translate.instant('resellerorder.resellerreturnordershort');
        else
            return $translate.instant('resellerorder.resellerordershort');
    }

    function containsStatus(status) {
        if (vm.searchTerm.orderStatuses.length === 0 && !vm.returnFilter) {
            return true;
        }
        if (_.find(vm.searchTerm.orderStatuses, function(o) { return o === status; })) {
            return true;
        }
    }

    function createNewOrder() {
        $state.go('resellerorder.resellerordercreate');
    }

    function createNewReturnOrder() {
        $state.go('resellerorder.resellerreturnordercreate');
    }

    function loadResellerOrders() {
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.getResellerOrders(vm.currentPage, vm.searchTerm.term, vm.itemsPerPage, vm.searchTerm.orderStatuses, vm.isFilterOrderForInvoice).then(function (response) {
            vm.resellerOrders = response.data.data.results;
            vm.totalItems = response.data.data.total;
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function loadResellerReturnOrders() {
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.getResellerReturnOrders(vm.currentPage, vm.searchTerm.term, vm.itemsPerPage, vm.searchTerm.orderStatuses).then(function (response) {
            vm.resellerOrders = response.data.data.results;
            vm.totalItems = response.data.data.total;
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function loadAllResellerOrders() {
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.getAllResellerOrders(vm.currentPage, vm.searchTerm.term, vm.itemsPerPage, vm.searchTerm.orderStatuses).then(function (response){
            vm.resellerOrders = response.data.data.results;
            vm.totalItems = response.data.data.total;
        }).finally(function(){
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function loadLocations() {
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.getStores().then(function (response) {
            vm.locations = response.stores;
            var newEmptyLocation = {
                id: -1,
                locationName: $translate.instant('common.allLocations')
            };
            vm.locations.unshift(newEmptyLocation);
            vm.searchTerm.selectedFromLocation = vm.locations[0];

            $scope.$watch(function () {
                return vm.searchTerm.selectedFromLocation ? vm.searchTerm.selectedFromLocation.id : undefined;
            }, function(oldValue, newValue) {
                if (oldValue !== newValue || newValue === -1) {
                    filterAllOrders();
                }
            });
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function searchTermChange() {    
        if((!vm.filterClosed && !vm.filterCreated && !vm.filterOpen) || (!vm.filterReturnOrder && !vm.filterOrder)){
            vm.resellerOrders = [];
            vm.totalItems = 0;
            vm.resellerOrderPrintList = [];
            $scope.checkall = false;
            $scope.checkeverything = false;
        }        
        else if((vm.filterOrder && !vm.filterReturnOrder) || vm.isFilterOrderForInvoice)
            loadResellerOrders();
        else if(vm.filterReturnOrder && !vm.filterOrder)
            loadResellerReturnOrders();
        else
            loadAllResellerOrders();
    }

    function selectOrder(order) {
        
            var state = _.find(order.links, function(o) { return o.rel === "state"; });
            switch(state.href) {
                case "modify": 
                if(order.orderType === 'ResellerReturnOrder'){
                    $state.go('resellerorder.resellerreturnordermodify', { orderId: order.id });
                } 
                else {
                    $state.go('resellerorder.resellerordermodify', { orderId: order.id });
                } break;
                default:
                case "fulfill":
                case "view": $state.go('resellerorder.resellerorderview', { orderId: order.id }); break;
        }
    }    

    function filterAllOrders(isCheckBoxAll){
        var statuses = [];
        if(isCheckBoxAll){
            if(vm.filterAll){
                vm.filterCreated = vm.filterOpen = vm.filterClosed = vm.filterReturnOrder = vm.filterOrder = true;
            }
            else{
                vm.filterCreated = vm.filterOpen = vm.filterClosed = vm.filterReturnOrder = vm.filterOrder = false;
            }
        }
        else if(vm.filterClosed && vm.filterCreated && vm.filterOpen && vm.filterReturnOrder && vm.filterOrder)
            vm.filterAll = true;
        else 
            vm.filterAll = false;

        if(vm.filterCreated)
            statuses.push('Created');
        if(vm.filterOpen)
            statuses.push('Open');
        if(vm.filterClosed)
            statuses.push('Closed');

        vm.resellerOrderPrintList = [];
        if(!$scope.checkeverything)
        {
            $scope.checkall = false;
        }
        else{
            checkAllToPrintList(true);
        }
        
        vm.searchTerm.orderStatuses = statuses;
        searchTermChange();
    }

    function getStatusTranslation(text) {
        if (text) {
            var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
            return $translate.instant('resellerorder.status' + textCapital);
        }
    }

    function getOrderTypeTranslation(text) {
        if (text) {
            var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
            return $translate.instant('resellerorder.type' + textCapital);
        }
    }
}
